const topHistory = (() => {

  let sW = window.innerWidth;
  let mapWrap = document.querySelector('.js-map-wrap');
  let Bg = document.querySelector('.js-map-bg');
  let cover = document.querySelector('.js-map-cover');
  let btn = document.querySelector('.js-map-btn');
  const fadeElem = document.querySelectorAll('.js-map-fade');
  let num

  if (sW > 750) {
    num = 103
  } else {
    num = 70
  }


  btn.addEventListener('click', (event) => {
    let bgHight = Bg.clientHeight;

    if (mapWrap.classList.contains('act') == true) {
      mapWrap.classList.remove('act');
      mapWrap.style.height = num + 'rem';
      btn.classList.remove('act');
      cover.classList.remove('none');
    } else {
      mapWrap.classList.add('act');
      mapWrap.style.height = bgHight + 'px';
      btn.classList.add('act');
      cover.classList.add('none');
    }

    for (let i = 0; i < fadeElem.length; i++) {

      gsap.set(fadeElem[i], {
        opacity: 0,
        y: 20,
      });

      gsap.to(fadeElem[i], {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "power1.out",
        scrollTrigger: {
          trigger: fadeElem[i],
          start: 'top 80%'
        }
      });

    }

  });

})();
export default topHistory;